import React, { useState, useEffect } from "react";
import "../pages/newProduct/newProduct.css"

import Button from "@material-ui/core/Button";
import {
  CreateNewProducts,
  UpdateProducts,
  deleteAProducts,
  getProducts,
} from "../Data/Products";

import firebase from "firebase/compat/app";
import { FStorage, firebase_Db } from "../config/firebaseConfig";
//imports

// Constants
const DBName = "products";
const Category = ["Category", "food", "store", "medical", "market", "gift"];


// product form components
function Products({ btnName, titleName, submitType, productData }) {
  const [Items, setItems] = useState({
    name: "",
    description: "",
    price: "",
    category: "",
    subCategory: "",
  });

  const [imageAsUrl, setImageAsUrl] = useState("");
  const [submit_type, setSubmitType] = useState(false);
  const [optOpen, setoptOpen] = useState(false);

  const { data, id } = productData;

  const [Arestaurants, setResaurants] = useState([]);

  useEffect(() => {
    const fetchrestaurants = async () => {
      const RestaurantCollection = await firebase_Db
        .collection("Restaurants")
        .orderBy("createdAt", "asc")
        .get();

      setResaurants(
        RestaurantCollection.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
      
    };

    
    return fetchrestaurants();
  }, []);

  useEffect(() => {
    function checkSubmit() {
      if (submitType === "Create") {
        setSubmitType(true);
      } else {
        setSubmitType(false);
      }
    }
    return checkSubmit();
  }, [submitType]);

  useEffect(() => {
    
    function checkOpt() {
      if ((Items.category === "food")) {
        setoptOpen(true);
      } 
      else{
        setoptOpen(false);
      }
    }

    return checkOpt();
  }, [Items.category]);

  const handleImageAsFile = async (e) => {
    const image = e.target.files[0];
    const storageRef = FStorage.ref("product_images");
    const fileRef = storageRef.child(
      `${Math.floor(Math.random() * 135) + 1}` + image.name
    );
    await fileRef.put(image);
    setImageAsUrl(await fileRef.getDownloadURL());
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setSubmitType(submitType);
    if (submit_type && Items.name && Items.description && Items.price) {
      const ref = firebase_Db.collection(DBName).doc();
      await firebase_Db
        .collection(DBName)
        .add({
          id: ref.id,
          name: Items.name,
          description: Items.description,
          price: Items.price,
          category: Items.category,
          subCategory: Items.subCategory,
          imgUrl: imageAsUrl,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        })
        .then(() => {
          alert("Product Added");
          setSubmitType("");
          setItems({
            name: "",
            description: "",
            price: "",
            category: "",
            subCategory: "",
          });
          setImageAsUrl(null);
        })
        .catch(() => {
          alert("Product not Added");
        });
    } else {
      await firebase_Db
        .collection(DBName)
        .doc(id)
        .update({
          name: Items.name || data.name,
          description: Items.description || data.description,
          price: Items.price || data.price,
          category: Items.category || data.category,
          subCategory: Items.subCategory || data.subCategory,
          imgUrl: imageAsUrl || data.imgUrl,
        })
        .then(() => {
          setSubmitType("");
          setItems({
            name: "",
            description: "",
            price: "",
            category: "",
            subCategory: "",
          });
          setImageAsUrl(null);
          alert("Product Updated");
        })
        .catch(() => {
          alert("Product not able to Updated");
        });
    }
  };

  return (
    <div className="newProduct">
      <h1 className="addProductTitle">{titleName}</h1>
      <form className="addProductForm" onSubmit={handleOnSubmit}>
        <div className="addProductItem">
          <label htmlFor="name">Name</label>
          <input
            name="name"
            id="name"
            type="text"
            placeholder="Enter Product Name"
            value={Items.name}
            onChange={(e) =>
              setItems((_) => {
                return { ...Items, name: e.target.value };
              })
            }
          />
        </div>
        <div className="addProductItem">
          <label htmlFor="description">Description</label>
          <textarea
            placeholder="Enter Product Description"
            name="description"
            id="description"
            rows="5"
            cols="50"
            value={Items.description}
            onChange={(e) =>
              setItems((_) => {
                return { ...Items, description: e.target.value };
              })
            }
          ></textarea>
        </div>
        <div className="addProductItem">
          <label htmlFor="price">Price</label>
          <input
            name="price"
            id="price"
            type="number"
            placeholder="Price of Product"
            value={Items.price}
            onChange={(e) =>
              setItems((_) => {
                return { ...Items, price: e.target.value };
              })
            }
          />
        </div>
        <div className="addProductItem">
          <label htmlFor="category">Category</label>
          <select
            value={Items.category}
            onChange={(e) =>
              setItems((name) => {
                return { ...Items, category: e.target.value };
              })
            }
            name="category"
            id="category"
          >
            {Category.map((cate, index) => {
              return (
                <option key={index} value={cate}>
                  {cate}
                </option>
              );
            })}
          </select>
          <label htmlFor="subCategory"> Sub Category</label>
          <select
            value={Items.subCategory}
            onChange={(e) =>
              setItems((name) => {
                return { ...Items, subCategory: e.target.value };
              })
            }
            name="subCategory"
            id="subCategory"
          >
            { optOpen ? Arestaurants.map((cate, index) => {
              const {data, id} = cate;
              return (
                <option key={index} value={data.name}>
                  {data.name}
                </option>
              );
            }) : <option value="none">None</option>}
          </select>
        </div>
        <div className="addProductItem">
          <label htmlFor="img_url">Image</label>
          <input type="file" name="img" id="img" onChange={handleImageAsFile} />
        </div>
        <Button variant="contained" color="primary" type="submit">
          {btnName}
        </Button>
      </form>
    </div>
  );
}

export default Products;
